import { premiumBillingControls } from './premium-billing-controls.js';
import { premiumRefundRequests, premiumHistoryProviders } from './premium-refund-requests.js';
import { premiumBillingFormat } from './premium-billing-format.js';
import { plusBillingRequest } from './plus-billing-request.js';

export function plusBilling(strings, billingUrl, binding, csrfToken, initialStatus, loadFailed, accountId, initialHistory = null) {
    let component;
    let onPageShow;
    const checkAccount = () => !component.expired;
    const expire = () => {
        component.expired = true;
        component.refundStoreProviders = [];
        component.billing.state = null;
        component.billing.confirmation = null;
        component.billing.requestToRetry = null;
        component.billing.notice = '';
        Object.assign(component.refunds, {
            opened: false, payments: [], receipts: [], selectedPayment: '', message: '', reason: 'other',
            requestToRetry: null, morePayments: false, moreReceipts: false,
        });
    };
    const request = plusBillingRequest(billingUrl, binding, csrfToken, checkAccount, expire);
    component = {
        ...premiumBillingFormat(strings),
        expired: false,
        canManageBilling: initialStatus !== null || loadFailed,
        storeNote: '',
        historyError: '',
        refundStoreProviders: premiumHistoryProviders(initialHistory, null),
        billingProvider: 'stripe',
        subscriptionLoadingText: strings.loading,
        billing: premiumBillingControls(request, strings, checkAccount, () => {}, accountId),
        refunds: premiumRefundRequests(request, strings, checkAccount, accountId),

        init() {
            component = this;
            this.billing.state = initialStatus;
            this.billing.error = loadFailed ? strings.loadError : '';
            this.billing.restorePending();
            this.refunds.restoreRequest();
            onPageShow = event => {
                if (event.persisted && checkAccount()) {
                    this.billing.state = null;
                    this.billing.load();
                    this.loadHistory();
                    if (this.refunds.opened) this.refunds.load();
                }
            };
            window.addEventListener('pageshow', onPageShow);
        },

        async loadHistory() {
            this.refundStoreProviders = [];
            this.historyError = '';
            try {
                const history = await request('/plus-billing-history');
                if (checkAccount()) this.refundStoreProviders = premiumHistoryProviders(history, null);
            } catch {
                if (checkAccount()) this.historyError = strings.loadError;
            }
        },

        destroy() {
            expire();
            window.removeEventListener('pageshow', onPageShow);
        },

        get canOpenPortal() {
            return !this.expired && this.billing.state !== null;
        },

        get renewalLine() {
            if (!this.canManageBilling) return strings.inactive;
            return this.billingLine(this.billing.requestToRetry || this.billing.working
                ? { state: 'pending' } : this.billing.state?.billing);
        },

        get accessLine() {
            const access = this.billing.state?.access;
            const date = access?.enabled ? this.formatDate(access.valid_until) : '';
            const settled = !this.billing.requestToRetry && !this.billing.working;
            return date && !(settled && this.repeatsEndDate(this.billing.state?.billing, date))
                ? strings.accessUntil.replace('%date%', date) : '';
        },
    };
    return component;
}
